import { backgroundOrange, darkOrange, gold, green, orange } from '@/theme/colors'
import styled from 'styled-components'

export const SectionRoot = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: 0;
`

export const SectionHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 0.75rem;
	padding-bottom: 0.875rem;
	border-bottom: 1px solid #f0e0d6;
	margin-bottom: 0.875rem;
	flex-shrink: 0;
	flex-wrap: wrap;
`

export const SectionTitle = styled.h3`
	margin: 0;
	font-size: 1.0625rem;
	font-weight: 700;
	color: ${darkOrange};
`

export const SectionHeaderActions = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	flex-wrap: wrap;
`

export const SectionBody = styled.div`
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	padding-right: 0.25rem;
	scrollbar-width: none;
	-ms-overflow-style: none;

	&::-webkit-scrollbar {
		display: none;
	}
`

export const HeaderActionButton = styled.button`
	background: ${orange};
	color: white;
	border: none;
	padding: 0.5rem 0.875rem;
	border-radius: 8px;
	font-size: 0.8125rem;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s ease;
	white-space: nowrap;

	&:hover {
		opacity: 0.9;
		transform: translateY(-1px);
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	}

	&:active {
		opacity: 0.85;
		transform: translateY(0);
	}
`

export const ExportButton = styled.button`
	padding: 0.5rem 0.875rem;
	border-radius: 8px;
	border: 1px solid #e5e7eb;
	background: white;
	color: #374151;
	font-size: 0.8125rem;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.15s;
	white-space: nowrap;

	&:hover:not(:disabled) {
		border-color: ${orange};
		background: #fef9f6;
	}

	&:disabled {
		opacity: 0.5;
		cursor: default;
	}
`

export const FilterButton = styled.button<{ $active?: boolean }>`
	display: inline-flex;
	align-items: center;
	gap: 0.375rem;
	padding: 0.5rem 0.875rem;
	border-radius: 8px;
	border: 1px solid ${({ $active }) => ($active ? orange : '#e5e7eb')};
	background: ${({ $active }) => ($active ? backgroundOrange : 'white')};
	color: ${({ $active }) => ($active ? darkOrange : '#374151')};
	font-size: 0.8125rem;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.15s;

	&:hover {
		border-color: ${orange};
		background: #fef9f6;
	}
`

export const FilterCountBadge = styled.span`
	background: ${orange};
	color: white;
	border-radius: 999px;
	padding: 0 0.4rem;
	font-size: 0.6875rem;
	font-weight: 700;
	min-width: 1rem;
	text-align: center;
`

export const ActivityList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.25rem;
`

export const DateGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.625rem;
`

export const DateHeader = styled.h4`
	font-size: 0.875rem;
	font-weight: 600;
	color: ${gold};
	text-transform: uppercase;
	letter-spacing: 0.05em;
	margin: 0 0 0.25rem 0;
	padding-bottom: 0.5rem;
	border-bottom: 1px solid #f0e0d6;
`

export const ActivityGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(26.5625rem, 1fr));
	gap: 0.75rem;

	@media (max-width: 600px) {
		grid-template-columns: 1fr;
	}
`

export const ActivityCard = styled.div`
	background: white;
	border-radius: 12px;
	padding: 1rem 1.125rem;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	gap: 1rem;
	cursor: pointer;
	transition: all 0.2s ease;
	border: 1px solid #f0e0d6;
	min-width: 0;
	min-height: 7rem;
	overflow: hidden;

	&:hover {
		transform: translateY(-1px);
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
	}
`

export const ActivityCardTop = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 0.5rem;
	min-width: 0;
	flex: 1;
`

export const ActivityCardLeft = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.125rem;
	min-width: 0;
	flex: 1;
`

export const ActivityCardName = styled.span`
	font-size: 0.9375rem;
	font-weight: 600;
	color: #262626;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`

export const ActivityCardMeta = styled.span`
	font-size: 0.75rem;
	color: #6b7280;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	display: flex;
	align-items: center;
	gap: 0.375rem;
`

export const ActivityCardThumbnail = styled.img`
	width: 2.5rem;
	height: 2.5rem;
	border-radius: 6px;
	object-fit: cover;
	flex-shrink: 0;
	border: 1px solid #f0e0d6;
`

export const ActivityCardBottom = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-top: 1px solid #f5ebe5;
	padding-top: 0.75rem;
	gap: 0.5rem;
	min-width: 0;
`

export const PayerLine = styled.div`
	display: flex;
	align-items: center;
	gap: 0.375rem;
	min-width: 0;
	flex: 1;
	font-size: 0.6875rem;
	font-weight: 500;
	color: #6b7280;
`

export const PayerName = styled.span<{ $highlight?: boolean }>`
	color: ${({ $highlight }) => ($highlight ? orange : '#374151')};
	font-weight: ${({ $highlight }) => ($highlight ? 700 : 500)};
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	min-width: 0;
`

export const PayerAmount = styled.span`
	color: ${orange};
	font-weight: 700;
	flex-shrink: 0;
`

export const PaidConnector = styled.span`
	flex-shrink: 0;
`

export const PayUpAvatarRow = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
`

export const PayUpArrow = styled.span`
	color: ${green};
	font-size: 1.25rem;
	font-weight: 700;
	line-height: 1;
`

export const PayUpMoneyIcon = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	color: ${green};

	svg {
		width: 1.75rem;
		height: 1.75rem;
	}
`

export const ActivityCardAmount = styled.span<{ $variant?: 'expense' | 'payup' }>`
	font-size: 1rem;
	font-weight: 700;
	color: ${({ $variant }) => ($variant === 'payup' ? green : darkOrange)};
`

export const ActivityCardCurrencyCode = styled.span`
	font-size: 0.75rem;
	font-weight: 500;
	color: #6b7280;
	margin-left: 0.25rem;
`

export const ActivityCardInvolvement = styled.span<{
	$type: 'lent' | 'borrowed' | 'none' | 'paid' | 'received'
}>`
	font-size: 0.6875rem;
	font-weight: 500;
	color: ${({ $type }) => {
		switch ($type) {
			case 'lent':
			case 'received':
				return '#16a34a'
			case 'borrowed':
			case 'paid':
				return '#dc2626'
			case 'none':
				return '#9ca3af'
		}
	}};
`

export const SplitBadge = styled.span`
	font-size: 0.6875rem;
	padding: 0.125rem 0.5rem;
	border-radius: 999px;
	background: #fef3e2;
	color: ${gold};
	font-weight: 500;
`

export const PayUpBadge = styled.span`
	font-size: 0.6875rem;
	padding: 0.125rem 0.5rem;
	border-radius: 999px;
	background: #e8f5ee;
	color: ${green};
	font-weight: 500;
`

export const EmptyActivityCard = styled.div`
	padding: 2rem 1rem;
	text-align: center;
	color: #6b7280;
	background: white;
	border: 1px dashed #f0e0d6;
	border-radius: 12px;
`
